export default __webpack_public_path__ + "static/hr-89b8c8af46eef412f1cd0433ed3c7bc5.svg";